export default class ImageMap {
  constructor( node ) {
    this.node = node;

    this.setOnClickToDialogElements();
    this.setOnClickToDialogOpenElements();
    this.setOnClickToDialogCloseElements();
  }
  setOnClickToDialogElements() {
    const elements = document.querySelectorAll('[data-dialog]');
    elements.forEach((element) => {
      element.onclick = function(e) {
        const dialogDimensions = element.getBoundingClientRect();
        if (
          e.clientX < dialogDimensions.left ||
          e.clientX > dialogDimensions.right ||
          e.clientY < dialogDimensions.top ||
          e.clientY > dialogDimensions.bottom
        ) {
          element.close()
        }
      };
    });
  }

  setOnClickToDialogOpenElements() {
    const elements = document.querySelectorAll('[data-open-dialog]');
    elements.forEach((element) => {
      element.onclick = function(e) {
        const dialog = e.target.parentNode.querySelector("[data-dialog]");
        dialog.showModal();
      };
    });
  }

  setOnClickToDialogCloseElements() {
    const elements = document.querySelectorAll('[data-close-dialog]');
    elements.forEach((element) => {
      element.onclick = function(e) {
        const dialog = e.target.parentNode;
        dialog.close();
      };
    });
  }
}
